export default __webpack_public_path__ + "static/card-placeholder-007ff91034eb171ba165cfcdf808d580.jpg";